import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.hitPerformancePerAbility.title',
    defaultMessage: 'Hit percentage by skill',
  },
  question: {
    id: 'reports.hitPerformancePerAbility.question',
    defaultMessage: 'Question',
  },
  ability: {
    id: 'reports.hitPerformancePerAbility.ability',
    defaultMessage: 'Abiliity',
  },
  curriculumComponent: {
    id: 'reports.hitPerformancePerAbility.curriculumComponent',
    defaultMessage: 'Curricular component',
  },
  hitPercentage: {
    id: 'reports.hitPerformancePerAbility.hitPercentage',
    defaultMessage: 'Percentage Hits by Course',
  },
});
